// Auto-generated from App\Enums\PersonRole
// Do not edit this file manually

export enum PersonRole {
  Employee = 'employee',
  Student = 'student',
  FutureStudent = 'future-student',
  ExStudent = 'ex-student',
  AdmissionApplicant = 'admission-applicant',
  ExAdmissionApplicant = 'ex-admission-applicant',
  Parent = 'parent',
  ParentOfStudent = 'parent-of-student',
  ParentOfFutureStudent = 'parent-of-future-student',
  ParentOfExStudent = 'parent-of-ex-student',
  ParentOfAdmissionApplicant = 'parent-of-admission-applicant',
  ParentOfExAdmissionApplicant = 'parent-of-ex-admission-applicant',
  ParentOfSmartStudent = 'parent-of-smart-student',
  ParentOfSmartExStudent = 'parent-of-smart-ex-student',
  Child = 'child',
  SmartStudent = 'smart-student',
  SmartExStudent = 'smart-ex-student',
  FamilyAssistant = 'family-assistant',
  Teacher = 'teacher',
  NoRole = 'no-role',
}
